import React, { useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as SuccessOverlayhSVG } from '@mirinae/lessons/assets/images/successoverlay.svg';

const SuccessBadge = styled(SuccessOverlayhSVG)`
    position: absolute;
    left: calc(50% - 115px);
    animation: fadeinout 2s linear forwards;

    @keyframes fadeinout {
        0% { opacity: 0 }
        25% { opacity: 0 } 
        35% { opacity: 1 }
        65% { opacity: 1 }
        75% { opacity: 0 } 
        100% { opacity: 0 }
    }
`;

const SuccessScreen = styled.div`
    position: absolute;
    width: ${props => (props.screenWidth ? props.screenWidth : '100%')};
    height: ${props => (props.height ? props.height : '230px')};
    left: ${props => (props.screenLeft ? props.screenLeft : 0)}px;
    background-color: rgba(255, 255, 255, 0.75);
    animation: screenFadeinout 2s linear forwards;

    @keyframes screenFadeinout {
        0% { opacity: 0 }
        12% { opacity: 1 }
        85% { opacity: 1 }
        100% { opacity: 0 }
    }
`;

const SuccessBanner = styled.div`
    position: absolute;
    z-index: 1000;
    width: 100%;
    ${props => {
        const pos = [];
        if (props.top) pos.push(`top: ${props.top}px;`);
        if (props.bottom) pos.push(`bottom: ${props.bottom}px;`);
        if (props.left) pos.push(`left: ${props.left}px;`);
        if (props.right) pos.push(`right: ${props.right}px;`);
        return pos.join(';');
    }}
`;

const SuccessOverlay = (props) => {
    const bannerRef = useRef(null);
    useEffect(() => {
        if (bannerRef.current && bannerRef.current.style) {
            bannerRef.current.style.display = 'block';
            setTimeout(() => { if (bannerRef.current) bannerRef.current.style.display = 'none'; }, 2000);
        }
    }, []);
    return (
        <SuccessBanner ref={bannerRef} {...props}>
            <SuccessScreen {...props} />
            <SuccessBadge />
        </SuccessBanner>
    );
};

export default SuccessOverlay;
